export default "__VITE_ASSET__DPZDswA8__"